module.exports = __webpack_public_path__ + "img/companyIntro30.fbb6bef5.png";